import flavourConfig from './config';
import prodConfig from './config-prod';

const config = {
  flavourConfig,
  prodConfig,
};

export default config;
